export const parseAcceptArray = (accepts: string[] = []): string => {
    return accepts?.map(ext => `.${ext}`).join(', ');
}